import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ProjectLogHeader = ({
  breadCrumbText,
  reloadList,
  changeStatusHandler,
  isProjectModerator,
  title,
  projectMemberStatus,
  projectModStatus,
  jsonFilterQuery = [], // Added jsonFilterQuery prop
  selectedLogIds = [], // Assuming a prop for selected log IDs for action menu logic
  updateBulkLogHandler = () => {},
  updateScheduleStateHandler = () => {},
  downloadAsExcel = () => {},
}) => {
  const { t } = useTranslation(); //for translation
  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            displayName={`${title}`}
            top={false}
          />
        </div>
        {isProjectModerator ||
        (projectMemberStatus === "1" && projectModStatus === "1") ? (
          <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
            {/* -------------- refresh ----------------- */}
            <Link
              onClick={reloadList}
              to="#"
              className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
              title={t("Reload")}
            >
              <span className="material-symbols-outlined icon-md me-1">
                refresh
              </span>
              <span className="fw-semibold small">{t("Reload")}</span>
            </Link>
            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Action")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                {/* --- add label start --- */}
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedLogIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    data-bs-toggle={
                      selectedLogIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedLogIds.length === 0 ? undefined : "#addLabelModal"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      label
                    </span>
                    <span className="d-block">{t("Manage Label")}</span>
                  </Link>
                </li>
                {/* --- add label start --- */}{" "}
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedLogIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    onClick={() => {
                      if (selectedLogIds.length > 0) {
                        updateBulkLogHandler();
                      }
                    }}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      progress_activity
                    </span>
                    <span className="d-block">{t("Update Log")}</span>
                  </Link>
                </li>
                <hr className="dropdown-divider" />
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="#"
                    onClick={downloadAsExcel}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      download
                    </span>
                    <span className="d-block">{t("Download as Excel")}</span>
                  </Link>
                </li>
                <hr className="dropdown-divider" />
                {/* <!-- ========== Start massive delete task Section ========== --> */}
                {isProjectModerator && (
                  <li>
                    <Link
                      to="#"
                      className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                        selectedLogIds.length === 0
                          ? "disabled text-muted"
                          : "text-danger"
                      }`}
                      data-bs-toggle={
                        selectedLogIds.length === 0 ? undefined : "modal"
                      }
                      data-bs-target={
                        selectedLogIds.length === 0
                          ? undefined
                          : "#projectLogDeleteModal"
                      }
                    >
                      <span className="d-block material-symbols-outlined icon-sm">
                        delete
                      </span>
                      <span className="d-block">{t("Delete Logs")}</span>
                    </Link>
                  </li>
                )}
                {/* <!-- ========== End massive delete task Section ========== --> */}
              </ul>
            </div>

            <Link
              to="#"
              className={`btn ${
                jsonFilterQuery.length > 0
                  ? "btn-outline-primary"
                  : "btn-light border"
              } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#logListAdvanceFilter"
              aria-controls="logListAdvanceFilter"
            >
              <span className="material-symbols-outlined icon-md me-1">
                tune
              </span>
              <span className="fw-semibold small">{t("Filter")}</span>
              <span
                className={
                  jsonFilterQuery.length > 0
                    ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                    : "d-none"
                }
                style={{ minWidth: 22, minHeight: 22 }}
              >
                {jsonFilterQuery.length}
              </span>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProjectLogHeader;
